import { Stack, type StackOwnProps, styled } from '@mui/material'

const CartListStack = styled<typeof Stack>((props: StackOwnProps) => (
  <Stack spacing={{ xs: 2, lg: 3 }} {...props} />
))()

export default CartListStack
